import * as React from 'react'
import RouterPage from './Pages/RouterPage'

function App() {
  return (
    <>


      <div className="App">
        <RouterPage />
      </div>
    </>
  )
}

export default App

